__turbopack_context__.v({
  "activeLanguage": "zFKgAW_activeLanguage",
  "item": "zFKgAW_item",
  "languageSelector": "zFKgAW_languageSelector",
  "localeSwitcher": "zFKgAW_localeSwitcher",
  "localeSwitcherIcon": "zFKgAW_localeSwitcherIcon",
  "localeSwitcherItem": "zFKgAW_localeSwitcherItem",
  "localeSwitcherItemActive": "zFKgAW_localeSwitcherItemActive",
});
